import { createContext, useState, ReactNode } from "react";

export type AlertType = {
  message: string;
  type?: "success" | "error" | "info";
};

type AlertContextType = {
  alert: AlertType | null;
  showAlert: (message: string, type?: "success" | "error" | "info") => void;
  clearAlert: () => void;
};

export const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider = ({ children }: { children: ReactNode }) => {
  const [alert, setAlert] = useState<AlertType | null>(null);

  const showAlert = (message: string, type: "success" | "error" | "info" = "success") => {
    setAlert({ message, type });
    setTimeout(() => setAlert(null), 2500);
  };

  const clearAlert = () => setAlert(null);

  return (
    <AlertContext.Provider value={{ alert, showAlert, clearAlert }}>
      {children}
    </AlertContext.Provider>
  );
};
